import { Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { LucideModule } from '../../modules/lucide.module';

export interface BreadcrumbItem {
  titulo: string;
  link: string;
}

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.css'],
  imports: [RouterLink, LucideModule],
})
export class BreadcrumbComponent {
  readonly pagina = input.required<string>();

  readonly intermediarios = input<readonly BreadcrumbItem[]>([]);
}
